import { Component, ComponentRef, inject, OnDestroy, OnInit, viewChild, ViewContainerRef } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { CustomContent } from '../../shared/services/custom-content/custom-content'
import { SeoService } from '../../shared/services/seo/seo-service'
import { SharedContent } from '../../shared/services/shared-content/shared-content'

@Component({
	selector: 'app-about-us',
	imports: [],
	templateUrl: './about-us.html',
	styleUrl: './about-us.css',
})
export class AboutUs implements OnInit, OnDestroy {
	viewContainer = inject(ViewContainerRef)
	container = viewChild.required('container', {
		read: ViewContainerRef,
	})

	urlSubscription!: Subscription

	private customContentService = inject(CustomContent)
	private sharedContentService = inject(SharedContent)
	private seoService = inject(SeoService)
	private route = inject(ActivatedRoute)

	ngOnInit(): void {
		this.urlSubscription = this.route.data.subscribe((resp) => {
			const cityPageContent = resp['content']
			this.sharedContentService.setPhoneNumber(cityPageContent.phoneNumber)
			this.seoService.setCanonicalURL()
			this.seoService.setPageMetaData(cityPageContent.title, cityPageContent.description)

			this.viewContainer.clear()
			Object.entries(cityPageContent.content).forEach((key) => {
				this.loadComponent(key[1])
			})
		})
	}

	loadComponent(key: any) {
		const componentType = this.customContentService.mapToComponentType(key.sharedComponentName)

		if (!componentType) return
		const componentRef: ComponentRef<any> = this.viewContainer.createComponent(componentType)

		// Set inputs for the dynamically created component
		componentRef.instance.content = key
	}

	ngOnDestroy(): void {
		this.viewContainer?.clear()
		this.urlSubscription?.unsubscribe()
	}
}
